import baseConfig from '../config.js';
import basicFormHelper from '../basic.form.helper.js';
import {regular} from '../validate.js.js';

//注明：如果列表中需要有编码，配置initCodeRules，则会自动加载XXDesc,XXCodeItems(XX表示数据项的属性名)
const columns: any = [
    {
        dataIndex: 'POSITION',
        title: '序号',
        width: '6%',
        scopedSlots: {
            customRender: 'num'
        }
    },
    {
        dataIndex: 'course.name',
        title: '课程名称',
        scopedSlots: {customRender: 'courseName'},
        width: '20%',
        ellipsis: true
    },
    {
        dataIndex: 'source',
        title: '课程来源',
        scopedSlots: {customRender: ''},
        customRender: (text: string) => {
            if (text == 'createByTeacher') {
                return '教师创作';
            }
            if (text == 'purchase') {
                return '渠道采购';
            }
        }
    },
    {
        dataIndex: 'course.subject',
        title: '课程类型'
    },
    {
        dataIndex: 'course.phases',
        title: '学段',
        ellipsis: true,
        scopedSlots: {customRender: 'coursePhases'}
    },
    {
        dataIndex: 'course.contentVersion',
        title: '最新版本',
        customRender: (text: number) => `v${((text + 10) / 10).toFixed(1)}`
    },
    {
        dataIndex: '',
        slots: {title: 'class'},
        scopedSlots: {customRender: 'class'}
    },
    {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: {customRender: 'operation'}
    }
];

const columnsClass: any = [
    {
        dataIndex: 'POSITION',
        title: '序号',
        scopedSlots: {
            customRender: 'serialNumber'
        }
    },
    {
        dataIndex: 'phases[0]',
        title: '所属学段',
        scopedSlots: {customRender: ''}
    },
    {
        dataIndex: 'className',
        title: '关联班级',
        customRender: (text: any) => {
            if (typeof text != 'string') {
                return text.name;
            } else {
                return text;
            }
        }
    },
    {
        dataIndex: 'associatedType',
        slots: {title: 'type'},
        customRender: (text: any) => {
            if (text == 'byAdmin') {
                return '学校管理员关联';
            } else if (text == 'byTeacher') {
                return '教师手动添加';
            }
        }
    },
    {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: {customRender: 'operation'}
    }
];

const form: any = {
    id: '',
    name: '',
    code: '',
    section: '',
    grades: '',
    subject: '',
    publisher: '',
    summary: '',
    sectionName: '',
    gradesName: '',
    subjectName: '',
    relativeIamge: '',
    checkUserId: ''
};

/**
 * 其实就是把本页面定义的form数据,重新copy一份数据出来
 */
const copyNewForm = function() {
    let jsonStr = JSON.stringify(form);
    let newForm = JSON.parse(jsonStr);
    return newForm;
};

/**
 * 把本地页面data中定义的form转换接口所需的数据格式
 * @param {Object} pageForm
 */
const convertDbForm = function(pageForm: any) {
    let dbForm = {
        ...{},
        ...pageForm
    };

    let codeStr = dbForm.code + '';
    dbForm.code = codeStr;

    return dbForm;
};

/**
 * 把通过查询返回的数据格式塞入到页面data的from属性中
 * @param {Object} dbFrom
 * @param {Object} contextForm
 */
const dbToForm = function(dbFrom: any, contextForm: any) {
    //赋值
    let newForm: any = {};

    for (let p in dbFrom) {
        newForm[p] = dbFrom[p];
    }
    return newForm;
};

export default {
    columns,
    columnsClass,

    form,
    copyNewForm: basicFormHelper.copyNewForm,

    convertDbForm,
    dbToForm,

    allowUploadTypes: basicFormHelper.allowUploadTypes
};
